import { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';

export default function BarcodeScanner({ onResult, onClose }) {
  const videoRef  = useRef(null);
  const readerRef = useRef(null);
  const doneRef   = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const reader = new BrowserMultiFormatReader();
    readerRef.current = reader;

    reader
      .decodeFromVideoDevice(null, videoRef.current, (result, err) => {
        if (result && !doneRef.current) {
          doneRef.current = true;
          if (navigator.vibrate) navigator.vibrate(100);
          onResult(result.getText());
        }
      })
      .catch(() => setError('Camera access denied. Please allow camera access and try again.'));

    return () => {
      reader.reset();
    };
  }, [onResult]);

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.96)',
      zIndex: 2000,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
    }}>
      {/* Header */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0,
        padding: '18px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>Scan Barcode</span>
        <button
          onClick={onClose}
          style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(255,255,255,0.12)', border: 'none',
            color: '#fff', fontSize: 18, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >✕</button>
      </div>

      {/* Viewfinder */}
      <div style={{ position: 'relative', width: '100%', maxWidth: 380 }}>
        <video
          ref={videoRef}
          style={{ width: '100%', borderRadius: 12, display: 'block' }}
        />

        {/* Corner markers */}
        <svg
          viewBox="0 0 100 100"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
        >
          {[
            ['0,0', '16,0', '0,16'],
            ['84,0', '100,0', '100,16'],
            ['0,84', '0,100', '16,100'],
            ['84,100', '100,100', '100,84'],
          ].map(([a, b, c], i) => (
            <polyline key={i} points={`${a} ${b} ${c}`} fill="none" stroke="#F0B429" strokeWidth="3" strokeLinecap="round" />
          ))}

          {/* Animated scan line */}
          <line x1="8" x2="92" stroke="rgba(240,180,41,0.7)" strokeWidth="1.5">
            <animate attributeName="y1" values="15;85;15" dur="2s" repeatCount="indefinite" />
            <animate attributeName="y2" values="15;85;15" dur="2s" repeatCount="indefinite" />
          </line>
        </svg>
      </div>

      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, marginTop: 20, textAlign: 'center' }}>
        Point camera at the product barcode
      </p>

      {error && (
        <p style={{ color: '#f87171', fontSize: 13, marginTop: 8, textAlign: 'center', padding: '0 24px' }}>
          {error}
        </p>
      )}

      <style>{`
        @keyframes scanline {
          0%, 100% { top: 15%; }
          50%       { top: 80%; }
        }
      `}</style>
    </div>
  );
}
